<template>
    <u-btn-icon-flat-tile v-bind="$attrs" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-icon-flat-tile>
</template>

<script>
import UBtnIconFlatTile from "@/components/publish/styles/buttons/u-btn-icon-flat-tile.vue";

export default {
    props: {
    },
    components: {
        UBtnIconFlatTile,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
